import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.notifications_index_page', () => {
  import('./internal/field-avatar').then(({ default: Component }) => Component());
});
